var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMaisAtacado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 181.43 55.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#dcc6b7;}.cls-3{fill:#515151;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_ATACADO",
    "data-name": " ATACADO",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.36,41.51H27.51v-3H38.36V27.64h3v10.9h10.8v3H41.38V52.36h-3Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.93,25.93h6.23L72.9,55.24H68.31l-1.47-7.62H60.65l-1.4,7.62H55Zm5.17,18L63.84,31.13h-.12L61.38,43.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.56,29.91H73V26H88.65v3.9h-5.5V55.24H78.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.68,25.93h6.23l5.74,29.31h-4.59l-1.48-7.62H94.39L93,55.24H88.73Zm5.16,18L97.59,31.13h-.13L95.13,43.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.82,48.56V32.65c0-4.43,3.28-7.09,7.79-7.09,4.22,0,7.22,2.5,7.22,6.52v3.24h-4.15V32.57a2.83,2.83,0,0,0-3.07-3.07c-2.21,0-3.2,1.39-3.2,3.32V48.27a3,3,0,0,0,3.24,3.36,2.83,2.83,0,0,0,3-3V45.85h4.15v3c0,4.18-3,6.8-7.22,6.8C112,55.65,108.82,53.23,108.82,48.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,25.93h6.23l5.74,29.31h-4.59l-1.47-7.62H132l-1.4,7.62h-4.26Zm5.17,18-2.26-12.76h-.12l-2.34,12.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.32,26H155c4.14,0,7.38,2.17,7.38,6.64V48.23c0,4.76-3.24,7-7.43,7h-7.62Zm7.26,25.3A3,3,0,0,0,157.77,48V33.1A2.91,2.91,0,0,0,154.58,30h-2.67V51.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.81,48.19V33c0-4.88,3.36-7.46,7.83-7.46s7.79,2.25,7.79,7.22V48.07c0,5.08-3.44,7.58-7.83,7.58C169,55.65,165.81,53.23,165.81,48.19Zm11,.08V32.69a3,3,0,0,0-3.24-3.15,3,3,0,0,0-3.2,3.24V48.27a3.07,3.07,0,0,0,3.24,3.32A3,3,0,0,0,176.84,48.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M0,.27H5.61C8.5.27,10.52,2,10.52,4.83c0,2.43-1.68,4.6-5,4.6H2.06v5.81H0ZM5.12,7.68c2.06,0,3.34-.94,3.34-2.85S7.16,2,5.33,2H2.06V7.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.5,10.43v-5C12.5,2,15.25,0,18.29,0c3.21,0,5.84,2,5.84,5.27v4.79c0,3.44-2.73,5.46-5.78,5.46S12.5,13.73,12.5,10.43Zm9.57-.25v-5c0-2.12-1.62-3.36-3.82-3.36a3.45,3.45,0,0,0-3.7,3.55v4.89c0,2.12,1.64,3.4,3.8,3.4A3.44,3.44,0,0,0,22.07,10.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M27,.27h5.51c2.85,0,4.95,1.62,4.95,4.54A4.25,4.25,0,0,1,34,9.13l4.13,6.11H35.89l-4-5.9H29v5.9H27Zm5.15,7.35c2.06,0,3.25-.92,3.25-2.83S34.08,2,32.09,2H29V7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M43.59,2.1H38.91V.27h11.4V2.1H45.65V15.24H43.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M55.21.25h1.91l5.52,15H60.48l-1.39-4h-6l-1.43,4H49.62ZM58.5,9.53l-2.37-6.8h0L53.7,9.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.7.27h2.06V13.42h7.58v1.82H64.7Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaisAtacado);
export default __webpack_public_path__ + "static/media/LogoMaisAtacado.3296275af4f056aeef7768bd22ba7895.svg";
export { ForwardRef as ReactComponent };